import React from 'react';
import { useHistory } from 'react-router-dom';
import { ratingTypes } from '../../../utils/constants';

export const ActionTypes = {
    POST_SCORE: 1,
    START_PERSONAL_CLUB: 2,
    FIND_EVENT: 3,
    COMPLETE_PROFILE: 4,
    CREATE_FIRST_EVENT: 5,
    COMPLETE_CLUB_PROFILE: 6,
    CREATE_PRO_CLUB: 8,
    CREATE_FREE_CLUB: 9,
    CREATE_POWER_CLUB: 10,
};

const ActionCard = props => {
    const { force, forceCardView, actionData, completed, onCloseClick, 'data-testid': dataTestId } = props;
    const actionCompleted = completed || actionData.completed;
    const history = useHistory();

    return (
        <div className={`utr-card action-card`}>
            <div
                className={`list-view ${forceCardView || (force && force.cardView) ? 'd-none' : 'd-none d-md-block'}`}
            />
            <div
                className={`card-view container ${forceCardView || (force && force.cardView) ? 'd-flex' : 'd-flex d-md-none'}`}
            >
                {actionCompleted && (
                    <i className={`uts uts-check-circle completed-check`} />
                )}
                <i className={`uts uts-close close`} onClick={() => { onCloseClick(actionData.id); }} data-testid={dataTestId && `${dataTestId}.close-btn`} />
                <div className="title title-uppercase" data-testid={dataTestId && `${dataTestId}.title`}>{actionData.title}</div>
                <div className="description" data-testid={dataTestId && `${dataTestId}.description`}>{actionData.description}</div>
                <button
                    type="button"
                    className={`btn btn-primary cta`}
                    disabled={actionCompleted}
                    onClick={() => {
                        if (actionData.redirectUrl && actionData.redirectUrl.length > 0) {
                            history.push(actionData.redirectUrl);
                        }
                    }}
                    data-testid={dataTestId && `${dataTestId}.cta-btn`}
                >
                    {actionData.ctaText}
                </button>
            </div>
        </div>
    );
};

export default ActionCard;

export const getActionCardData = (data) => {
    const object = {};
    switch (data.type) {
        case ActionTypes.POST_SCORE:
            object.id = `${data.type}`;
            object.title = 'Post a score';
            object.description = `Add results from individual matches to count towards your ${ratingTypes.tennis} rating.`;
            object.ctaText = 'Post Score';
            object.redirectUrl = '/post-score-select';
            break;
        case ActionTypes.START_PERSONAL_CLUB:
            object.id = `${data.type}`;
            object.title = 'Start a personal club';
            object.description = 'Organize play for your group of tennis friends.';
            object.ctaText = 'Create Personal Club';
            object.redirectUrl = '/create-players-group';
            break;
        case ActionTypes.FIND_EVENT:
            object.id = `${data.type}`;
            object.title = 'Find Play';
            object.description = 'Find play at an event.';
            object.ctaText = 'Find Event';
            object.redirectUrl = '/explore';
            break;
        case ActionTypes.COMPLETE_PROFILE:
            object.id = `${data.type}`;
            object.title = 'Showcase your tennis';
            object.description = 'Add images, achievements and player preferences.';
            object.ctaText = 'Complete profile';
            object.redirectUrl = `/profiles/${data.playerId}/edit`;
            break;
        case ActionTypes.CREATE_FIRST_EVENT:
            object.id = `${data.type}`;
            object.title = 'Create your first event';
            object.description = 'Organize level based play with UTR Sports.';
            object.ctaText = 'Create Event';
            object.redirectUrl = '/events/create';
            break;
        case ActionTypes.COMPLETE_CLUB_PROFILE:
            object.id = `${data.type}`;
            object.title = 'Showcase your Club';
            object.description = 'Add photos and description to your club profile.';
            object.ctaText = 'Complete Club Profile';
            object.redirectUrl = data.clubId ? `/clubs/${data.clubId}/edit` : ''; // TODO: can we determine club type?
            break;
        case ActionTypes.CREATE_PRO_CLUB:
            object.id = `${data.type}`;
            object.title = 'Create your Pro Club';
            object.description = 'Organize players, run events, and more.';
            object.ctaText = 'Create Club';
            object.redirectUrl = `/create`;
            break;
        case ActionTypes.CREATE_FREE_CLUB:
            object.id = `${data.type}`;
            object.title = 'Create your Free Club';
            object.description = 'Set up your free personal club';
            object.ctaText = 'Create Club';
            object.redirectUrl = `/create-players-group`;
            break;
        case ActionTypes.CREATE_POWER_CLUB:
            object.id = `${data.type}`;
            object.title = 'Create your Power Club';
            object.description = 'Set up your Power personal club';
            object.ctaText = 'Create Club';
            object.redirectUrl = `/create-players-group`;
            break;
        default:
            break;
    }
    return object;
};
